var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSintEustatius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00268d",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    d: "M0 0h30v24H0zm2 2v20h26V2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    d: "M16 0h-2v24h2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    d: "M0 11v2h30v-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.45 6.1 15 5.89l-.45.23-10 5-1.79.89 1.8.9 10 5 .44.22.45-.23 10-5 1.79-.89-1.8-.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#059334",
    d: "M10.6 16H19l3.58-1.53s-2.83-3.03-3-3.17c-.2-.14-.5-.2-.84.24-.34.45-.53-.24-.82-.24s-.4 0-.82.57l-1.9 2.6H13s-.36-.34-.57-.22-1.4-1.32-1.82-1.42c-.42-.11-.7.39-.7.78 0 .4-.2-.36-.6-.14-.4.23-.28.78-.28.78z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    d: "m15 5 11.3 5.27L30 12l-15 7-11.3-5.27L0 12l3.7-1.73 10.37-4.84zm0 2.16L4.64 12 15 16.84 25.36 12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#feda00",
    d: "m14.7 11.25-1.04.75.38-1.23-1.04-.75h1.3l.4-1.22.44 1.22h1.26l-1.03.75.4 1.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSintEustatius);
export default __webpack_public_path__ + "static/media/sint-eustatius.bf52ec0a73ceb558f74e9daaaa195c73.svg";
export { ForwardRef as ReactComponent };